// This function takes a component...
import React, {ComponentType, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes, forwardRef, useEffect, useState} from "react";
import {getShopInfosInStorage} from "../components/cart/ShopInfos";
import {getHostApi} from "../utils";

export interface TranslationProps {
  textsContent: Record<string, string|undefined>;
}

export const WithTranslation = <P extends TranslationProps = TranslationProps, R = unknown>(WrappedComponent: ComponentType<P>, ...groupNames: string[]): ForwardRefExoticComponent<PropsWithoutRef<Omit<P, "textsContent">> & RefAttributes<R>> => {
  return forwardRef<R, Omit<P, keyof TranslationProps>>((props, ref): JSX.Element => {
    const [textsContent, setTextsContent] = useState<Record<string, string|undefined>>({});
    const [dataIsFullyLoad, setDataIsFullyLoad] = useState<boolean>(false);

    useEffect(() => {
      const shopInfos = getShopInfosInStorage();
      const idShop = shopInfos?.idBoutique ? parseInt(shopInfos.idBoutique) : 0;
      const translationService = new TranslationService(getHostApi(), idShop);

      let texts: Record<string, string | undefined> = {};
      let groupsToLoad = groupNames.length;

      const onSuccess = (data: Record<string, string>) => {
        texts = { ...texts, ...data };
      };

      const onFinally = () => {
        groupsToLoad -= 1;
        if (groupsToLoad === 0) {
          setTextsContent({ ...texts });
          setDataIsFullyLoad(true);
        }
      };

      if (groupNames.length === 0) {
        setDataIsFullyLoad(true);
      } else {
        for (const group of groupNames) {
          translationService.fetchContentsByGroupName(group, false, onSuccess, undefined, onFinally);
        }
      }
    }, [groupNames]);

    return (
      <>
        {dataIsFullyLoad && Object.keys(textsContent).length > 0 && <WrappedComponent { ...props } textsContent={textsContent} ref={ref} />}
      </>
    );
  });
};
